// extracted by mini-css-extract-plugin
export var contentBody = "_8r-9";
export var headerImage = "_8r-2";
export var imageButton = "_8r-7";
export var imageButtonIcon = "_8r-8";
export var imageHeader = "_8r-4";
export var imageHeaderText = "_8r-5";
export var imageOverlay = "_8r-3";
export var imageTitle = "_8r-6";
export var imageWrapper = "_8r-1";
export var taskList = "_8r-a";
export var widget = "_8r-0";